import { Box, Button, Flex } from "@chakra-ui/react"
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router"
import { useState } from "react"
import { FaBars } from "react-icons/fa"

import MobileBanner from "@/components/Common/MobileBanner"
import Navbar from "@/components/Common/Navbar"
import Sidebar from "@/components/Common/Sidebar"
import { ImpersonationBanner } from "@/components/Impersonation/ImpersonationBanner"
import { isLoggedIn } from "@/hooks/useAuth"
import { isEmbeddedSession } from "@/utils"

export const Route = createFileRoute("/_layout")({
  component: Layout,
  beforeLoad: async () => {
    if (!isLoggedIn()) {
      throw redirect({
        to: "/login",
      })
    }
  },
})

function Layout() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const isEmbed = isEmbeddedSession()

  return (
    <Flex direction="column" h="100vh" bg="bg.canvas">
      <Box className="no-print">
        <ImpersonationBanner />
      </Box>
      {!isEmbed && (
        <Box className="no-print">
          <Navbar />
        </Box>
      )}
      <Box className="no-print">
        <MobileBanner
          compact={isEmbed}
          onMenuOpen={() => setIsMobileMenuOpen(true)}
        />
      </Box>
      <Flex flex="1" overflow="hidden" minH={0}>
        <Box className="no-print">
          <Sidebar
            isCollapsed={isSidebarCollapsed}
            onCollapse={() => setIsSidebarCollapsed(true)}
            mobileOpen={isMobileMenuOpen}
            onMobileOpenChange={setIsMobileMenuOpen}
          />
        </Box>
        <Flex flex="1" direction="column" minH={0} minW={0} position="relative">
          {isSidebarCollapsed && (
            <Flex
              justify="flex-start"
              px={{ base: 2, md: 4 }}
              pt={{ base: 3, md: 4 }}
              className="no-print"
            >
              <Button
                aria-label="Expand sidebar"
                variant="subtle"
                size="sm"
                onClick={() => setIsSidebarCollapsed(false)}
                display={{ base: "none", md: "inline-flex" }}
                gap={2}
              >
                <FaBars />
                Menu
              </Button>
            </Flex>
          )}
          <Box
            as="main"
            flex="1"
            minW={0}
            overflowY="auto"
            px={{ base: 2, md: 6 }}
            py={{ base: 4, md: 6 }}
            bg="bg.canvas"
          >
            <Outlet />
          </Box>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default Layout
